import { owcTheme } from '@one/design-tokens/js/regular/navify/light';
import { OwcModalDialog } from '@one/react';
import styled from 'styled-components';

export const InactivityWarningLayout = styled(OwcModalDialog)`
  owc-card {
    width: fit-content;
    max-width: min(28rem, 80vw);
    margin: 0 auto;
  }
`;

export const InactivityWarningBody = styled.div`
  padding: ${owcTheme['one-spacing-base-4']};
`;

export const InactivityWarningFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${owcTheme['one-spacing-base-2']};
`;
